import { render, staticRenderFns } from "./MagazzinoIngresso.vue?vue&type=template&id=32b34dde&"
import script from "./MagazzinoIngresso.vue?vue&type=script&lang=js&"
export * from "./MagazzinoIngresso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports